<template>
    <div >
      <MdTitle v-bind:Text="$t('Medication.Medications')" />
      <div class="row">
        <div class="col-sm-12 col-md-12 mb-4">
          <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
            <div class="input-group" dir="ltr">
              <input 
                type="text" 
                class="form-control"
                :dir="dirInput"
                v-model="parameter.SearchCriteria"   
                  @keyup.enter="SearchMedications"                            
              >
              <div class="input-group-append">
                <div class="input-group-append">
                  <MdButton 
                    v-bind:Name="'btnsearchinput'"
                    v-bind:VariantProp="'btn btn-sm search-attached'"
                    v-bind:IconClass="'mdi mdi-magnify'"
                    v-on:click="SearchMedications">
                  </MdButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <b-row>
          <b-col lg="3" md="3" sm="12">
            <!--<MdEdit 
              v-bind:Label="$t('Shared.datefrom')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'datefrom'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateFrom"
              v-bind:isRequired="true">                                     
            </MdEdit>-->
            <MdDateTime 
              :Label="$t('Shared.datefrom')" 
              :Model="dateFrom"                           
              @input="dateFrom = $event"                            
              :Id="'PatientMedFiltersRepDateFrom'"
              :Type="'date'" 
              :OnPressEnter="SearchMedications"                         
              :isConfirm="false"
              :ReadOnly="false">
          </MdDateTime>

          </b-col>
          <b-col lg="3" md="3" sm="12">
            <!--<MdEdit 
              v-bind:Label="$t('Shared.dateTo')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'dateto'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateTo"
              v-bind:isRequired="true">                                     
            </MdEdit>-->
          <MdDateTime 
              :Label="$t('Shared.dateTo')" 
              :Model="dateTo"                           
              @input="dateTo = $event"                            
              :Id="'PatientMedFiltersRepDateTo'"
              :Type="'date'" 
              :OnPressEnter="SearchMedications"                         
              :isConfirm="false"
              :ReadOnly="false">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Medication.MedicationStatus')"
              v-bind:Options="StatusOptions"
              v-bind:ModelArray="showStatusModel"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'"
              v-bind:Multiple="false"
              :Input="ChangeDropDownStatus"/>
          </b-col> 
          <b-col md="3" lg="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.Prescriber')"
              v-bind:Options="PrescriberList"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Multiple="true"                                
              :Input="ChangeDropDownPrescriber"
            />
          </b-col> 
          <b-col md="3" lg="3" sm="12">
            <MdSelect
                v-bind:Label="$t('Medication.Drugs')"
                v-bind:Options="DrugList"
                v-bind:FieldDescription="'drugName'"
                v-bind:FieldCode="'code'"
                v-bind:Multiple="true"                                
                :Input="ChangeDropDownDrug"
            />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.AdmissionStatus')"
              v-bind:Options="showOptions"
              v-bind:Model="showIsActiveAdmissionModel"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'" 
              v-bind:Multiple="false"                      
              :Input="ChangeIsActiveAdmission"
              v-bind:AllowEmpty="false"/>
          </b-col> 
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$tc('Shared.PatientStatus')"
                v-bind:Options="showOptions"
                v-bind:Model="showPatientIsActiveModel"
                v-bind:FieldDescription="'text'"
                v-bind:FieldCode="'value'" 
                v-bind:Multiple="false"                      
                :Input="ChangeIsActive"
                v-bind:AllowEmpty="false"/>
          </b-col>          
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$tc('Shared.Patient',2)"
              v-bind:Options="PatientsList"
              v-bind:FieldDescription="'patientName'"
              v-bind:FieldCode="'patientcode'"
              v-bind:Multiple="true"             
              :Input="ChangeDropDownPatients"
              :CustomLabel="customLabelPatients"/>
          </b-col>
        </b-row>
        <b-row>
         <b-col>
            <div class="text-md-right">
                <button 
                    v-on:click="SearchMedications"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col> 
     
        </b-row>
        <div class="row">
          <div class="col-12 mt-2">
             <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

            <div class="row">
              <div class="col-md-12">
               
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    v-bind:FieldsDate="FieldsDateArr">
                  </MdTable>
              </div>
            </div>
          </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>
            
          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   
        </div>

      
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('PatientMedications.ReportMedications')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportPatientMedFilters"
          :ReportName="'PatientMedFilters'"
          :ReportTitle="$t('PatientMedications.ReportMedications')"
          :IsAnAPIReport="true"
        />
    </DxPopup>
     <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('PatientMedications.ReportMedications')"
        v-bind:sendEmailAPI="'/Utils/sendEmail'"
        v-bind:exportCsvAPI="'/PatientMedications/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import PatientService from '@/services/patient.service'
  import MedicationService from '@/services/medication.service'
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import EnumService from "@/services/enum.service";
  import Utils from '../../../common/utils'
  import { EventBus } from '@/event-bus.js';

  export default Vue.extend({
    name: "patientMedFiltersRep",
    mixins: [ ShowMessage, DBFunctions ],
    components: { DxPopup },
    data() {
      return {
        isParamVisible: true,
        isReportVisible: false,
        dateFrom: '',
        dateTo: '',
        reportParams: [],
        PatientsList:[],
        PrescriberList:[],
        DrugList:[],
        ModelPrescriber:'',
        showOptions: [
          { value: "all", text: this.$t('Shared.All') },
          { value: "true", text:this.$t('Shared.Active') },
          { value: "false", text: this.$t('Shared.Inactive') },
        ],
        showPatientIsActiveModel: {
          "value":"true",
          "text":this.$t('Shared.Active')
        },
        showIsActiveAdmissionModel: {
          "value":"true",
          "text":this.$t('Shared.Active')
        },
        parameter:{
          SearchCriteria:'',
          PageNumber : 0,
          PageSize:0
        },
        params: {
          "PatientCodeList": [],
          "DrugCodeList": [],
          "PrescriberCodeList": [],
          "IsActive": true,
          "Status": true,
          "IsActiveAdmission": true
        },
        BaseFieldsDrug:[
            { key: 'drugName', sortable: true, label: this.$t('Shared.DrugName')},
            { key: 'activeIngredients', sortable: true, label: this.$t('Shared.activeIngredients')},
            { key: 'code', sortable: true, label: this.$t('Shared.Code')}
        ],
        StatusOptions: EnumService.MedicationStatusReport,
        showStatusModel : {
          "value": "ALL", 
          "text": this.$t('Shared.All') 
        },
        items: [],         
        fields: [
          { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' } ,
          { key: 'patientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-rigth' } , 
          { key: 'dob', sortable: true, label:this.$t('Shared.Dob'), class: 'text-rigth' },    
          { key: 'startDateTime', sortable: true, label: this.$t('Shared.StartDate'), class: 'text-rigth' },    
          { key: 'endDateTime', sortable: true, label: this.$t('Shared.EndDate'), class: 'text-rigth' },    
          { key: 'days', sortable: true, label:this.$t('Shared.Days'), class: 'text-rigth' },       
          { key: 'drugName', sortable: true, label:this.$t('Shared.DrugName'), class: 'text-rigth' },       
          { key: 'activeIngredients', sortable: true, label:this.$t('Shared.activeIngredients'), class: 'text-rigth' },       
          { key: 'sig', sortable: true, label: this.$t('Shared.Sig'), class: 'text-rigth'},       
          { key: 'prescriberName', sortable: true, label: this.$t('Shared.Prescriber'), class: 'text-rigth'},     
          { key: 'rxStatus', sortable: true, label:this.$t('Shared.Status'), class: 'text-rigth' }, 
          { key: 'recordId', sortable: true, label: 'RecordId', class: 'hidden' },
          
        ],
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        selected: [],
        Header:{},
        refTable: 'selectableTable', 
        ShowMessageIsEmpty:true,
        FieldsDateArr:['startDateTime','endDateTime','stopDateTime'],
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
      }
    },
    methods: {

      ChangeDropDownStatus(item) {
        this.params.Status = item.value 
      },

      onShowing(e) {
        let contentElement = e.component.content();
        let titleElement = e.component._$title[0]
        contentElement.style.padding = '0px';
        titleElement.style.padding = '0px 20px'
      },

      onHiddenReport() {
        this.isReportVisible = false
      },

      ChangeDropDownPatients(values) {
        this.params.PatientCodeList = [];
        values.forEach(it => {
          this.params.PatientCodeList.push(it.patientcode)
        });
      },

      customLabelPatients ({ PatientName, patientcode }) {
        return `${PatientName} – ${patientcode}`
      },

      ChangeDropDownPrescriber(values) {
        this.params.PrescriberCodeList = [];
        values.forEach(it => {
          this.params.PrescriberCodeList.push(it.code)
        });
      },
      
      ChangeDropDownDrug(values) {
        this.params.DrugCodeList = [];
          values.forEach(it => {
            this.params.DrugCodeList.push(it.code)
          });
      },

      getItemsByComma(values, field) {
        let len = values.length;
        let valuesSeparated = [];
        if (len > 0){
          var i = 0;
          values.forEach(function(e) {   
            if(i < len-1){
              valuesSeparated += e[field]+",";
            }else{
              valuesSeparated += e[field];
            }
            i++;                    
          });
          return valuesSeparated;
        } else {
          return [];
        }
      },

      ChangeIsActive(item) {
        this.params.IsActive = item.value
      },
      ChangeIsActiveAdmission(item) {
        this.params.IsActiveAdmission = item.value
      },
      
      getPatients() { 
        PatientService.getPatientList(this.parameter)
        .then((response) => {
          if(response.status == '200' && response.data && response.data.length > 0){
            this.PatientsList = response.data;
            this.PatientsList.forEach(function(element) {
              element.PatientName = element.firstname + " " + element.lastname;   
            });
          }
        })
        .catch(error => {
          if (!error.response) {
          // network error
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
          } else {
            this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        });
      },

      async getPrescribers(){
        await MedicationService
          .getPrescribers()
          .then((response) => {
              if(response.status == '200' && response.data){                        
                  this.PrescriberList = response.data;
              }
          })
          .catch((error) => {
              if (!error.response) {            
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
              } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
          });        
      },

      async getDrugs() { 
        await MedicationService.getDrugs()
        .then((response) => {
          if(response.status == '200' && response.data && response.data.length > 0){
            this.DrugList = response.data;
          }
        })
        .catch(error => {
          if (!error.response) {
          // network error
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
          } else {
            this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        });
      },
      onClickClose() {
        this.isParamVisible = false;
      },

      reportList() {
          this.checkExistFavorite('/app/reports/patients');
          this.$router.push({ name: "reportListPatient" }).catch(()=>{});
      },

      initializePdfParameters() {
        this.reportParams = []
        this.reportParams.push({ paramName: 'pStartDate', paramValue: this.dateFrom})
        this.reportParams.push({ paramName: 'pEndDate', paramValue: this.dateTo})
        this.reportParams.push({ paramName: 'pPatientCodeList',paramValue: this.params.PatientCodeList })
        this.reportParams.push({ paramName: 'pDrugCodeList',paramValue: this.params.DrugCodeList })
        this.reportParams.push({ paramName: 'pPrescriberCodeList',paramValue:this.params.PrescriberCodeList })
        this.reportParams.push({ paramName: 'pPatientStatus', paramValue: this.params.IsActive})
        this.reportParams.push({ paramName: 'pAdmissionStatus', paramValue: this.params.IsActiveAdmission})
        this.reportParams.push({ paramName: 'rSearchCriteria', paramValue: this.parameter.SearchCriteria})
        this.reportParams.push({ paramName: 'pStatus', paramValue: this.params.Status})
      },

      initializeParameters() {
          // Inicializa propiedades con null
        ['PatientCode', 'IsActive', 'IsActiveAdmission', 'Status'].forEach(
            key => this.parameter[key] = null
        );

        this.parameter.Status = (this.params.Status === 'All') ? null : this.params.Status;       
        this.parameter.DrugCodeList = this.params.DrugCodeList && this.params.DrugCodeList !== '' 
            ? this.params.DrugCodeList 
            : null;
        this.parameter.PrescriberCodeList = this.params.PrescriberCodeList && this.params.PrescriberCodeList !== '' 
            ? this.params.PrescriberCodeList 
            : null;
        this.parameter.IsActive = (this.params.IsActive === 'all') ? null : this.params.IsActive;
        this.parameter.PatientCodeList = this.params.PatientCodeList && this.params.PatientCodeList !== '' 
            ? this.params.PatientCodeList 
            : null;
        
        this.parameter.DateFrom = this.dateFrom;
        this.parameter.DateTo = this.dateTo;
        this.parameter.IsActiveAdmission = (this.params.IsActiveAdmission === 'all') ? null : this.params.IsActiveAdmission;
        this.parameter.buildingRestriction = this.$store.state.restrictions.buildingLocation;
      },

      onClickShowReport() {
        this.isParamVisible = false
        this.initializePdfParameters();
        this.isReportVisible = true
        this.$refs.reportPatientMedFilters.buildDocument(this.reportParams)
      },

      SearchMedications(){
        this.items = [];
        this.currentPage = 1;
        this.parameter.PageNumber = 1;
        this.totalRows = this.items.length;
        this.getMedications();
      },

      pageChanged (page) {            
        this.currentPage = page;    
        this.getMedications();     
      },

      PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
        this.getMedications();  
      },

      async getMedications() {
        this.parameter.PageNumber = this.currentPage;
        this.parameter.PageSize = this.perPage;

        this.initializeParameters();   
        
        await MedicationService.getAll(this.parameter, true)
          .then((response) => {
            if (response.status == "200" && response.data && response.data.length > 0) {
              this.items = response.data;
              
              this.totalRows =  this.items[0].maxRows;  
              this.items.forEach(function(item) {
                if (item.startDateTime)	
                    item.startDateTime = Utils.formatterDateTimeToString(item.startDateTime);
                if (item.endDateTime)	
                    item.endDateTime = Utils.formatterDateTimeToString(item.endDateTime);
                if (item.dob)	
                    item.dob = Utils.formatterDateToString(item.dob);
              });      
            }
            if(this.items.length === 0){
              this.ShowMessageIsEmpty = true;
            }
          })
          .catch((error) => {
            /*if (!error.response) {            
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
            } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
            }*/
            this.showResponseErrorMessage(error);
          });
      },
        
      handleCSV(action) {
        this.initializeParameters();
        try {
          switch(action) {
            case 'export':
              this.$refs.csvExportHelper.exportCSV(this.parameter);
            break;
            case 'email':
              this.$refs.csvExportHelper.emailCSV(this.parameter);
            break;
            default:
              console.warn('unknow action:', action);
            break;
          }
        } catch (error) {
            this.showResponseErrorMessage(error);
        }
      },
      handlePdf(action) {
        this.initializePdfParameters();
        try {
          switch(action) {
            case 'export':
              this.$refs.csvExportHelper.exportToPdf('PatientMedFilters', true, false, this.reportParams);
            break;
            case 'email':
              this.$refs.csvExportHelper.emailPdf('PatientMedFilters', true, false, this.reportParams);
            break;
          default:
              console.warn('unknow action:', action);
            break;
          }
        } catch (error) {
          this.showResponseErrorMessage(error);
        }
      }
    },
    
    async mounted () {
      this.getPatients();
      this.getDrugs();
      this.getPrescribers();
      EventBus.$on("ShowWeel", function (isShow) { 
          isShow ? this.$emit('load', true) : this.$emit('load', false);     
      }.bind(this));
    },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
